import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import AppManager from "../../managers/AppManager";
import ShiftManagementService from "../../services/ShiftManagementService";
import { deepClone, removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import { parseColumnConfig, parseVisibleColumnConfig, ShiftMembersColumnConfig } from "../configs/config";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaginatedShifts, selectPaginatedShifts } from "../../Redux/Slices/ShiftManagementSlice";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ic_no_data from "../../assets/icons/ic_no_data_3.png";
import { DKLabel, DKIcon } from "deskera-ui-library";
import { MODULE } from "../user-permissions/PermissionUtils";

function ShiftMembers(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [shiftData, setShiftData] = useState({
        columnData: [],
        rowData: [],
        filter: [],
        originalData: []
    });

    const shifts = useSelector(selectPaginatedShifts);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        getShifts(ShiftManagementService.getDefaultApiConfig());
    }, []);

    useEffect(() => {
        if (shifts) {
            prepareGridData(shifts.data);
            setTotalPageCount(shifts.filterConfig.totalPage);
        }
    }, [shifts]);

    const getShifts = async (apiConfig) => {
        const timeout = showDelayedLoader();
        
        if (apiConfig) {
            ShiftManagementService.API_CONFIG = apiConfig;
        }
        await dispatch(fetchPaginatedShifts());

        removeDelayedLoader(timeout);
    }

    const prepareGridData = (shifts) => {
        const columnConfig = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_SHIFT_MEMBERS), TABLES.PEOPLE_SHIFT_MEMBERS, {}));
        const shiftData = {
            columnData: deepClone(columnConfig),
            rowData: [],
            filter: [],
            originalData: []
        };

        if (shifts?.length > 0) {
            const rowData = ShiftMembersColumnConfig(shifts);
            shiftData.rowData = rowData;
            shiftData.originalData = rowData;
    
            setShiftData(shiftData);
        } else {
            setShiftData(shiftData);
        }
    }

    const viewAssignedMembers = (data) => {
        if (data?.rowData?.data) {
            ShiftManagementService.SHIFT = data.rowData.data;
            RouteManager.navigateToPage(PAGE_ROUTES.ASSIGN_MEMBERS);
        }
    }

    return (
        <Fragment>
            {TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED) &&
                <div className="mt-l">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_SHIFT_MEMBERS}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_SHIFT_MEMBERS]}
                        allowBulkOperation={true}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={false}
                        showContextEdit={false}
                        contextMenu={false}
                        isMenuVisible={false}
                        showContextMenu={false}
                        isActionEnabled={true}
                        gridData={shiftData}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        onRowEdit={(data) => {
                            viewAssignedMembers(data);
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            setCurrentPage(requestedPageNumber);

                            ShiftManagementService.API_CONFIG.currentPage = requestedPageNumber;
                            getShifts(ShiftManagementService.API_CONFIG);
                        }}
                        module={MODULE.SHIFT_ASSIGNMENT}
                    />
                </div>
            }
            {!TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED) &&
                <div className="row justify-content-center">
                    <div className="column align-items-center position-absolute" style={{ top: "30%", pointerEvents: "none" }}>
                        <DKIcon
                            src={ic_no_data}
                            className="ic-l"
                            style={{ opacity: 0.2, marginTop: 70 }}
                        />
                        <DKLabel text={t("SHIFT_MANAGEMENT_NOT_ENABLED")} className="fw-m mt-m text-align-center" />
                    </div>
                </div>
            }
        </Fragment>
    );
}

export default ShiftMembers;
